import React from "react";

import CreatePersonelRoutesAutomation from "./CreatePersonelRoutesAutomation";

const CreateShiftRoutesAutomation = ({ onClose }) => {
  return (
    <React.Fragment>
      <CreatePersonelRoutesAutomation onClose={onClose} isShiftService={true} />
    </React.Fragment>
  );
};

export default CreateShiftRoutesAutomation;
